/** @format */

import type { HomrVisualAssets } from '@shared/data-access/interfaces';
import { IPromotion } from './promotion.interface';

export interface SpotContentItem {
  Subhead: string;
  headline: string;
  link: string;
  visualAssets: [HomrVisualAssets];
  cta: {
    link: string;
    linkTitle: string;
  }[];
  buttonStyle?: string;
  altText?: string;
  Scene7ImagePath?: string;
  badgeText?: string;
}

export interface SpotContentItemVisualAsset {
  type: string;
  altText: string;
  value: string;
}

export interface DealDrawer {
  autoOpenLinkName?: string;
  drawerPageName?: string;
  image: string;
  link?: string;
  message: string;
  visualAssets: [HomrVisualAssets];
}

export interface ThreeSpot {
  'Promotional Banner'?: IPromotion[];
  'Spot 1'?: SpotContentItem[];
  'Spot 2'?: SpotContentItem[];
  'Spot 3'?: SpotContentItem[];
  'Google Ad Manager'?: SpotContentItem[];
}

export type OneSpot = Omit<ThreeSpot, 'Spot 2' | 'Spot 3'>;
